import { render } from "./InvoiceTabInvoiceInfo.vue?vue&type=template&id=64ad2175&scoped=true"
import script from "./InvoiceTabInvoiceInfo.vue?vue&type=script&lang=js"
export * from "./InvoiceTabInvoiceInfo.vue?vue&type=script&lang=js"

import "./InvoiceTabInvoiceInfo.vue?vue&type=style&index=0&id=64ad2175&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ad2175"]])

export default __exports__